var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 3.25,
    stroke: "#94A3B8",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13672 3.63635H5.65185L14.7426 15.7574H13.2275L4.13672 3.63635Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86328 3.63635H8.37841L17.4692 15.7574H15.9541L6.86328 3.63635Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34766 3.63635H8.37791V4.84845H5.34766V3.63635Z",
    fill: "#94A3B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2266 15.7576H16.2568V14.5455H13.2266V15.7576Z",
    fill: "#94A3B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7404 3.63635H16.8615L6.55868 15.7574H4.4375L14.7404 3.63635Z",
    fill: "#94A3B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0d5afadb851efcd539c6fcd3c93c1c0d.svg";
export { ForwardRef as ReactComponent };